import { Component, OnInit, Input } from '@angular/core'; 
import { CorizeBaseComponent } from '../../models/base-corize-component';
 

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css']
})
export class ImageComponent  extends CorizeBaseComponent implements OnInit { 
  @Input() imageSource: string;  
  public loading :boolean = false;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
